import { CHAPTERS, waLink } from "../../data/content";
import { Reveal } from "./Reveal";

const PORTRAIT = "https://customer-assets-cm19k8pv.emergentagent.net/job_luz-sagrada-tarot/artifacts/m8yta22d_boveda.jpeg";

export const Manifesto = () => (
  <section id="sobre-mi" data-testid="about-section" className="relative py-24 md:py-32 bg-[#0A0614]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-12 gap-14">
      <div className="md:col-span-5 md:sticky md:top-28 self-start">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.3em] text-[#C5A059]">Sobre mí</span>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl text-[#F3EFE7] leading-tight">
            Un don al servicio<br />de la gente
          </h2>
          <div className="relative mt-8 max-w-sm">
            <div className="absolute -inset-3 rounded-3xl bg-gradient-to-br from-[#C5A059]/40 to-transparent blur-xl" />
            <img src={PORTRAIT} alt="Bóveda espiritual de santería con muñeca conga, pañuelos de las 7 potencias africanas y aguas para el trabajo espiritista"
              className="relative rounded-2xl border border-[#C5A059]/30 object-cover w-full aspect-[4/3]" />
          </div>
          <p className="mt-8 text-white/70 leading-relaxed max-w-sm">
            "Quiero compartir mi don para ayudar a la gente." Con eso me levanto cada mañana.
          </p>
          <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="about-whatsapp"
            className="mt-6 inline-block rounded-full bg-[#C5A059] text-[#05030A] px-7 py-3.5 font-medium hover:bg-[#D4AF37] transition-colors duration-300">
            Hablar conmigo
          </a>
        </Reveal>
      </div>

      <div className="md:col-span-7 space-y-14">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.05}>
            <div className="flex gap-6 border-b border-white/10 pb-14 last:border-0">
              <span className="font-serif text-5xl md:text-6xl text-[#C5A059]/40 leading-none shrink-0 w-16">{c.n}</span>
              <div>
                <h3 className="font-serif text-2xl md:text-3xl text-[#F3EFE7]">{c.title}</h3>
                <p className="mt-3 text-white/70 leading-relaxed">{c.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
